import style from "./style.module.scss";
import { BsCardImage } from "react-icons/bs";
import { ImCross } from "react-icons/im";
import { useState, useEffect, useRef } from "react";

function UplistItem({ file, removeFile, retry, uploadStatus }) {
    // const [state, setState] = useState((file.name == "dl.png") ? 2 : 0);

    var stateColor = `${(uploadStatus.state < 1) && style.item_ready}
                      ${(uploadStatus.state == 1) && style.item_processing}
                      ${(uploadStatus.state == 2) && style.item_completed}
                      ${(uploadStatus.state == 3) && "bg-danger"}`

    var container = useRef();

    useEffect(() => {
        if (uploadStatus.state == 3) container.current.scrollIntoView({ behavior: "smooth", block: "center" });
    });

    return (
        <div ref={container} className={`${style.uplist_item} ${stateColor}`} >

            <div className={`${style.uplist_item_u}`}>
                <div className="d-flex" style={{ width: "80%" }}>
                    <BsCardImage size="23" style={{ transform: 'translate' }} />
                    <div style={{ minWidth: "5px" }}></div>
                    <div className={style.filenametxt}>
                        <div style={{ width: "4000px" }}>{file.name}</div>
                    </div>
                </div>

                {(uploadStatus.state < 0) && <div className="d-flex align-items-center">
                    <ImCross onClick={() => { removeFile(file); }} />
                </div>}
            </div>

            {(uploadStatus.state == 1) && <div className={`${style.uplist_item_d} d-flex flex-column align-items-center`}>
                <div className={`progress ${style.progress} w-100`}>
                    <div className={`progress-bar ${style.progress_bar}`} style={{ width: uploadStatus.progress + "%" }}></div>
                </div>
            </div>}

            {(uploadStatus.state == 3) && <div className="d-flex justify-content-center textwhite">
                <div style={{ color: "white" }}>
                    Error uploading
                    <button onClick={() => { retry(file) }} className="btn-sm btn-secondary " type="button" style={{ transform: "scale(0.8)" }}>try again</button>
                </div>
            </div>
            }
        </div>
    );

}

export default UplistItem;